module.exports = __webpack_public_path__ + "static/media/15UN-Habitat9.50facd47.jpg";